import React, { useEffect, useMemo, useRef } from "react";
import { observer } from "mobx-react";
import { UserAttachmentEditionViewStore } from "../../store";
import { UserAttachmentEditionView } from "./UserAttachmentEditionView";
import { useRootStore } from "../../../../store/contexts/RootStoreContext";
import { Box, CircularProgress } from "@mui/material";

export type UserAttachmentEditionDrawerContentProps = {
  entityId: string;
  mode?: "view" | "update";
};

export const UserAttachmentEditionDrawerContent: React.FC<UserAttachmentEditionDrawerContentProps> =
  observer(({ entityId, mode = "view" }) => {
    const rootStore = useRootStore();
    const viewInitializedRef = useRef<string | null>(null);

    const viewStore = useMemo(() => {
      const s = new UserAttachmentEditionViewStore(rootStore);
      s.isDrawerMode = true;
      return s;
    }, [rootStore]);

    useEffect(() => {
      if (
        mode === "view" &&
        entityId &&
        viewInitializedRef.current !== entityId
      ) {
        viewInitializedRef.current = entityId;
        viewStore.initialize({ id: entityId });
      }
    }, [entityId, mode, viewStore]);

    if (
      viewStore.status === "processing" ||
      viewStore.status === "uninitialized"
    ) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 200,
          }}
        >
          <CircularProgress />
        </Box>
      );
    }

    return (
      <UserAttachmentEditionView userAttachmentEditionViewStore={viewStore} />
    );
  });
